import PropTypes from 'prop-types';
import React from 'react';
import { getFooterButtonClasses } from './util/dashboardCardHelpers';

var FooterButton = function FooterButton(_ref) {
  var primary = _ref.primary,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return null;
  } : _ref$onClick,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '#' : _ref$href,
      text = _ref.text,
      unpurchasedPremium = _ref.unpurchasedPremium,
      secondaryGray = _ref.secondaryGray,
      mz = _ref.mz;
  return /*#__PURE__*/React.createElement("a", {
    className: getFooterButtonClasses(primary, unpurchasedPremium, secondaryGray),
    onClick: onClick,
    href: href,
    "data-mz": !!mz,
    "data-module": mz
  }, text);
};

FooterButton.displayName = "FooterButton";
FooterButton.propTypes = {
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  href: PropTypes.text,
  text: PropTypes.string.isRequired,
  unpurchasedPremium: PropTypes.bool,
  secondaryGray: PropTypes.text,
  mz: PropTypes.string
};
export default FooterButton;